import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { rootSlice } from "../createRootSlice";
import { muiDataGridStarted } from "../apiutils";
import { ENV_TYPES } from '../../components/global/Sidebar';

import { config } from "../apiUrlConfig";

export const userSlice =  rootSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUsersSelect: builder.query({
            query: (args) => ({
                url: `/users/select${args?.filter ? `?filter=${args.filter}` : ''}`,
                method: 'GET',
            }),
        }),
        getUsers: builder.query({
            query: ({ args, invalidate }) => ({
                url: `/users?page=${args.page}&size=${args.size}`,
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, args) => [{ type: 'Users' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getUsers', 'Users')
        }),
        getUsersSelect: builder.query({
            query: (args) => ({
                url: `/users/select${args?.filter ? `?filter=${args.filter}` : ''}`,
                method: 'GET',
            }),
            providesTags: (result, error, args) => [{ type: 'Users' }],
        }),
        addTempRelation: builder.mutation({
            query: (body) => ({
                url: `/users/addtemprelation`,
                method: 'POST',
                body: body
            }),
        }),
        addTempCustomer: builder.mutation({
            query: (body) => ({
                url: `/users/addtempcustomer`,
                method: 'POST',
                body: body
            }),
        }),
        getUser: builder.query({ 
            query: (id) => ({ 
                url: `/users/${id}`, 
                method: 'GET', 
            }),
            providesTags: (result, error, id) => [{ type: 'Users', id }],
        }),
        getExisting: builder.query({ 
            query: (email) => ({ 
                url: `/users/existing`, 
                method: 'POST', 
                body: {email: email}
            }),
            //providesTags: (result, error, arg) => [{ type: `existing`}],
        }),
        signup: builder.mutation({ 
            query: (user) => ({ 
                url: `/users/signup`, 
                method: 'POST', 
                body: {user}
            }),
            invalidatesTags: (result, error, user) => [{ type: 'Users' }],
        }),
        editUser: builder.mutation({ 
            query: (props) => ({ 
                url: `/users/${props.body.id ?? props.id}`, 
                method: 'PUT', 
                body: props.body,
            }),                   
            invalidatesTags: (result, error, props) => [{ type: 'Users', id: props.body.id }],
        }),
        deleteUser: builder.mutation({ 
            query: (user) => ({ 
                url: `/users/${user.id}`,
                method: 'DELETE', 
                headers: {
                    'customer_id': user.customerId
                }
            }),
            invalidatesTags: (result, error, user) => [{ type: 'Users' }],
        }),
        getCustomers: builder.query({
            query: () => ({
                url: `/customers/`,
                method: 'GET',
            }),
            providesTags: () => [{ type: 'Customers' }],
        }),
        updateCustomer: builder.mutation({
            query: (body) => ({
                url: `/customers/update`,
                method: 'PUT',
                body: body,
            }),
            invalidatesTags: () => [{ type: 'Customers' }],
        }),
        getCustomerLogo: builder.query({
            query: (_envId) => ({
                url: '/customers/logo',
                method:"GET",
            }),
            providesTags: () => [{ type: 'CustomerLogo' }],
        }),
        updateCustomerFulfilmentLogo: builder.mutation({
            queryFn: async (file, api) => {
                const formData = new FormData();
                formData.append('logo', file);  // field name must match upload.single('logo')

                const state = api.getState();
                const token = state.auth.token;
                const type = state.settings.environment.selectedEnvironmentType;
                const selectedId = state.settings.environment.selectedId;
                const relationCustomerId = state.settings.environment.relationCustomerId;

                const headers = {};
                if (token) headers['Authorization'] = `Bearer ${token}`;
                if (type === ENV_TYPES[100]) {
                    headers['customer_id'] = String(selectedId);
                } else if (type === ENV_TYPES[200]) {
                    headers['customer_id'] = String(relationCustomerId);
                }

                try {
                    const response = await fetch(`${config.url.API_ROOT_URL}customers/logo`, {
                        method: 'PUT',
                        headers,
                        body: formData,
                    });

                    if (!response.ok) {
                        return { error: { status: response.status, data: await response.json() } };
                    }

                    return { data: await response.json() };
                } catch (error) {
                    return { error: { status: 'FETCH_ERROR', error: error.message } };
                }
            },
            invalidatesTags: () => [{ type: 'CustomerLogo' }],
        }),
        deleteCustomerFulfilmentLogo: builder.mutation({
            query: () => ({
                url: `/customers/logo`,
                method: 'DELETE',
            }),
            invalidatesTags: () => [{ type: 'CustomerLogo' }],
        }),
        // updateCustomerFulfilmentLogo: builder.mutation({
        //     query: file => {
        //         const formData = new FormData();
        //         formData.append('logo', file);  // renamed
        //         return {
        //             url: `/customers/logo`,
        //             method: 'PUT',
        //             body: formData,
        //             formData: true,  // RTK Query hint — though it does the right thing automatically if Content-Type isn't pre-set
        //         };
        //     },
        //     invalidatesTags: (result, error, arg) => [{ type: 'Customers' }],
        // }),
    }),

});

export const {
    useGetUsersQuery,
    useGetUsersSelectQuery,
    useGetUserQuery,
    useGetExistingQuery,
    useSignupMutation,
    useEditUserMutation,
    useDeleteUserMutation,
    useGetUsersRelationQuery,
    useAddTempRelationMutation,
    useAddTempCustomerMutation,
    useGetCustomersQuery,
    useUpdateCustomerMutation,
    useGetCustomerLogoQuery,
    useUpdateCustomerFulfilmentLogoMutation,
    useDeleteCustomerFulfilmentLogoMutation,
} = rootSlice;
